import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class SearchIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fillRule="evenodd" d="M15.721 14.423a.897.897 0 0 1 .001 1.299.918.918 0 0 1-.65.278.916.916 0 0 1-.649-.278L9.6 10.899a5.983 5.983 0 0 1-3.571 1.159A6.016 6.016 0 0 1 0 6.029 6.017 6.017 0 0 1 6.03 0a6.016 6.016 0 0 1 6.028 6.028c0 1.346-.417 2.598-1.16 3.571l4.823 4.824zm-9.692-4.22a4.157 4.157 0 0 0 4.174-4.174A4.156 4.156 0 0 0 6.03 1.856a4.156 4.156 0 0 0-4.173 4.173 4.156 4.156 0 0 0 4.173 4.174z"/></svg>
        )
    }
}

export default withCssClassName(SearchIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/search-icon.js